import { GET_REPORT_DATA } from './mutation-types'

export default {
  [GET_REPORT_DATA]: (state, dadosRelatorio) => {
    state.dadosRelatorio = dadosRelatorio
  },
}
